import { ComponentRef, ViewContainerRef } from "@angular/core";
import { UpdateMultiFactorAuthComponent } from "./update-multi-factor-auth.component";


class UpdateMultiFactorAuthSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    viewContainerRef: ViewContainerRef;
    updateMultiFactorAuthComponentRef: ComponentRef<UpdateMultiFactorAuthComponent>;

    constructor(formId: string, payload: object) {

        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {

      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        this.viewContainerRef.clear();
        this.updateMultiFactorAuthComponentRef = this.viewContainerRef.createComponent(UpdateMultiFactorAuthComponent);

        this.updateMultiFactorAuthComponentRef.instance.onMFAProfileSubmit = this.onMFAProfileUpdateSubmit.bind(this);

        this.updateMultiFactorAuthComponentRef.instance.emailStatus = this.clientContext['MFAEmailStatus'];
        this.updateMultiFactorAuthComponentRef.instance.numberStatus = this.clientContext['MFAMobileStatus'];

        this.updateMultiFactorAuthComponentRef.instance.email = this.clientContext['email_mfa'];
        this.updateMultiFactorAuthComponentRef.instance.number = this.clientContext['mobile_mfa'];

        const journeyPayload = this.payload as JourneyPayload;

        return new Promise((resolve, reject) => {
          this.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));

              this.submitBlock = null;
            } catch (e) {

              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {

      }

      onError(payload: object): void {

      }

      private onMFAProfileUpdateSubmit(payload: object) {
        const data = payload;
        this.submitBlock(data);
      }
}

interface JourneyPayload {
    actions: ActionsInPayload[];
    stat: string;
    code: string;
    flow: string;
  }

interface ActionsInPayload {
    [key: string]: any;
  }

export default UpdateMultiFactorAuthSession;
